import styled from 'styled-components'

import { BasketBoostSVG } from '@src/components/SVGS/BasketBoostSVG'

export const Container = styled.div``

export const SpaceBetweenRow = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  margin: 0px 0px 4px;
`

export const Header = styled.h1`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0px;
`

export const SubHeader = styled.h2`
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
`

export const MainContainer = styled.div`
  background-color: #f6f6f9;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  margin: 0 0 16px 0;
  border-radius: 8px;
`

export const FulfilmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  white-space: nowrap;
`

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0px;
  margin: 0px;
  padding: 8px 8px 8px 8px;
`

export const HiddenRow = styled.tr`
  // Hide the table headers visually but show them to screen readers
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  font-size: 0px;
`

export const RowContainer = styled.div`
  margin: 4px 0px;
`

export const Row = styled.tr`
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  display: flex;
`

export const TableData = styled.td`
  font-weight: 700;
  &:nth-child(even) {
    text-align: left;
  }
`

export const OptionItemContainer = styled.div`
  padding: 0;
  margin-top: 4px;
`

export const DiscountNotice = styled.div`
  display: flex;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: white;
  border-radius: 4px;
  padding: 8px 12px;
  align-items: center;
`

export const Divider = styled.div`
  width: 120%;
  height: 4px;
  background-color: #fff;
  align-self: center;
  overflow: hidden;
`

export const StyledBasketBoostSVG = styled(BasketBoostSVG)`
  width: 16px;
  height: 16px;
  margin: 0 8px;
`

export const StyledCouponContainer = styled.div`
  color: ${({ theme }) => theme.colors.discount};
`

export const CouponContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const LabelledCouponContainer = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.colors.brand};
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`

export const PaddedDotSpan = styled.span`
  margin: 0 6px;
  padding-bottom: 1px;
`
